import { render, staticRenderFns } from "./UploadDocumentsModal.vue?vue&type=template&id=7bf8d5ce&scoped=true&"
import script from "./UploadDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentsModal.vue?vue&type=style&index=0&id=7bf8d5ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8d5ce",
  null
  
)

export default component.exports